import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import DriverScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import { IFindUserInformation } from "../../../types/common.interface";
import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import Cookies from "js-cookie";

const SuperAgentDriverContainer = () => {
  let cityInfo: any;

  Cookies.get("city") != "undefined"
    ? (cityInfo = JSON.parse(Cookies.get("city") as string))
    : (cityInfo = undefined);

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedDriver, setSelectedDriver] = React.useState<any>();
  // ? Carrying last year's drivers into the selected year: the checkbox that also lists them, and the rows ticked
  // ? for transfer. Both are cleared by a successful transfer.
  const [includePreviousYear, setIncludePreviousYear] = React.useState<boolean>(false);
  const [selectedDriverIds, setSelectedDriverIds] = React.useState<string[]>([]);
  const [requestDriver, setRequestDriver] =
    React.useState<IFindUserInformation>({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultDriver = useQuery(
    [values.useQueryKeys.getAllDriver, requestDriver, selectedYear?._id, includePreviousYear],
    () =>
      api.post.superAgent.findDriver({
        limit: requestDriver.limit,
        page: requestDriver.page,
        search: requestDriver.search,
        filters: requestDriver.filters,
        academicYear: selectedYear?._id,
        includePreviousYear,
      })
  );
  const { refetch } = resultDriver;
  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------

  async function transferFunction(driverIds: string[]) {
    setIsLoading(true);
    const result = await api.post.common.transferDriversToAcademicYear({
      driverIds,
      academicYear: String(selectedYear?._id),
    });
    if (result) {
      utils.successHandler(Number(result.CODE));
      setSelectedDriverIds([]);
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  async function createFunction(formData: ICreateAndUpdateDriver) {
    setIsLoading(true);
    const result = await api.post.common.createDriverByAdmin({
      ...formData,
      city: cityInfo?._id,
      province: cityInfo?.ProvinceId,
    });
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultDriver.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateDriver) {
    setIsLoading(true);
    const result = await api.put.common.updateDriverByAdmin(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultDriver.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.common.deleteDriver(userId);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultDriver.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function approveFunction(userId: string) {
    setIsLoading(true);
    const result = await api.put.common.approveDriver(userId);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultDriver.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.DriverScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        requestDriver,
        createFunction,
        updateFunction,
        deleteFunction,
        selectedDriver,
        approveFunction,
        setRequestDriver,
        transferFunction,
        selectedDriverIds,
        setSelectedDriverIds,
        includePreviousYear,
        setIncludePreviousYear,
        setSelectedDriver,
      }}
    >
      <DriverScreen resultDriver={resultDriver} role="SUPER_AGENT_SCHOOL" />
      <DeleteModal
        data={selectedDriver}
        user={selectedDriver}
        open={showModal === "DELETE"}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      />
    </Context.DriverScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default SuperAgentDriverContainer;
